import { render } from "./OrderNow.vue?vue&type=template&id=27994cfe"
import script from "./OrderNow.vue?vue&type=script&lang=js"
export * from "./OrderNow.vue?vue&type=script&lang=js"

import "./OrderNow.vue?vue&type=style&index=0&id=27994cfe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__